<template>
  <component :is="component" :href="href" @click.stop.prevent="wrappedClick">
    <slot />
  </component>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  props: {
    component: {
      type: String,
      required: false,
      default: 'a',
    },
    onClick: {
      type: Function,
      required: false,
      default: () => {},
    },
    to: {
      type: Object,
      required: true,
    },
    rightClickOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup() {
    const router = useRouter();
    return { router };
  },

  computed: {
    // Only followed on middle-click / open-in-new-tab; the click handler below routes in-page.
    href() {
      return this.router.resolve(this.to).href;
    },
  },

  methods: {
    async wrappedClick() {
      // Await function if async
      await this.onClick();
      if (!this.rightClickOnly) {
        const newTo = {
          ...this.to,
          query: {
            ...this.$route.query, // Preserve current query
            ...(this.to.query || {}),
          },
        };
        // Change route after having been run
        this.$router.push(newTo);
      }
    },
  },
};
</script>
